// vuex store methods for School Quality Snapshot and collected submodules

import sqs2025 from './2025'
import sqs2024 from './2024'
import sqs2023 from './2023'
import sqs2022 from './2022'
import sqs2021 from './2021'
import sqs2020 from './2020'
import sqs2019 from './2019'
import sqs2018 from './2018'
import sqs2017 from './2017'

import { yearRangeForReportYear } from '@/utils/data'

// initial state
const state = {
  reportYear: 0,
  routeSchool: {}
}

// getters
const getters = {
  reportYear: state => state.reportYear,
  routeSchool: state => state.routeSchool,
  schoolYearRange: state => yearRangeForReportYear(state.reportYear),
  previousYearBaseUrl: state => `/snapshot/${state.reportYear - 1}/`
}

// actions
const actions = {
}

// mutations
const mutations = {
  setReportYear (state, year) {
    state.reportYear = year
  },
  setRouteSchool (state, school) {
    state.routeSchool = school
  },
  clearRouteSchool (state) {
    state.routeSchool = {}
  }
}

// modules
const modules = {
  2025: sqs2025,
  2024: sqs2024,
  2023: sqs2023,
  2022: sqs2022,
  2021: sqs2021,
  2020: sqs2020,
  2019: sqs2019,
  2018: sqs2018,
  2017: sqs2017
}

// Initialize report years in each submodule, if they exist
Object.keys(modules).forEach(y => {
  const m = modules[y]
  const f = m.mutations.initReportYear
  if (f) f(m.state, y)
})

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules
}



// WEBPACK FOOTER //
// ./src/store/modules/sqs/index.js